// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160334/js/" + chunkId + "." + {"44":"0835969f","225":"c0f41771","481":"b09b315a","486":"74d2bf0c","770":"813d2749"}[chunkId] + ".0.3761361570302434.chunk.js";
};